import { Injectable } from '@angular/core';

@Injectable()
export class AuthService {
    public administrador = false;
    public keyFirebase: string = "";
    public verMenu: boolean = false
    public urlDeepLink: string = "";
    public dataSim : any;
    public iconFooterSelect : string = "home";
    public offset = (new Date().getTimezoneOffset());

    private readonly loginAtKey = 'loginAt';

    constructor() { }

    isLoggedIn() {
        return sessionStorage.getItem('userData') ? true : false;
    }

    login(user, password, remember?) {
    }

    logout() {
        sessionStorage.removeItem('userData');
        sessionStorage.removeItem('roles');
        this.clearLoginAt();
    }

    set userData(userData: any) {
        sessionStorage.setItem('userData', JSON.stringify(userData));
    }
    get userData() {
        return this.isLoggedIn() ? JSON.parse(sessionStorage.getItem('userData')) : null
    }

    set roles(rolesData: any) {
        sessionStorage.setItem('roles', JSON.stringify(rolesData));
    }
    get roles() {
        return this.isLoggedIn() ? JSON.parse(sessionStorage.getItem('roles')) : null
    }

    /** Marca el inicio de sesión (Date.now()). */
    markLoginAt(timestamp?: number): void {
        const value = timestamp != null ? timestamp : Date.now();
        sessionStorage.setItem(this.loginAtKey, String(value));
    }

    getLoginAt(): number | null {
        const raw = sessionStorage.getItem(this.loginAtKey);
        if (!raw) {
            return null;
        }
        const n = parseInt(raw, 10);
        return isNaN(n) ? null : n;
    }

    clearLoginAt(): void {
        sessionStorage.removeItem(this.loginAtKey);
    }

    /** Si hay sesión pero no loginAt (sesión previa al feature), inicia el contador ahora. */
    ensureLoginAt(): void {
        if (this.isLoggedIn() && this.getLoginAt() == null) {
            this.markLoginAt();
        }
    }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/shared/auth/auth.service.ts